// extracted by mini-css-extract-plugin
export default {"container":"styles_container__Yg286","tabBar":"styles_tabBar__CLnD8","tabContainer":"styles_tabContainer__VGlyY","tab":"styles_tab__cxD4n","active":"styles_active__T-CBq"};